<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2022-01-09 13:23:33
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-01-09 13:33:06
-->
<template>
  <div class="login">
    <el-tabs type="border-card" class="login-tab">
      <el-tab-pane label="密码登录"><login-by-password /></el-tab-pane>
      <el-tab-pane label="短信验证码登录"><login-by-code /></el-tab-pane>
    </el-tabs>
    <div class="login-register">
      没有帐号？点击<span class="login-register-btn" @click="onGotoRegister"
        >注册</span
      >
    </div>
  </div>
</template>

<script>
import LoginByPassword from "../components/LoginByPassword.vue";
import LoginByCode from "../components/LoginByCode.vue";
export default {
  name: "Login",
  components: {
    LoginByPassword,
    LoginByCode,
  },
  methods: {
    onGotoRegister() {
      this.$router.push({
        name: "register",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  &-tab {
    position: relative;
    width: 520px;
    max-width: 100%;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 8px;
  }
  &-register {
    padding: 24px 0;
    padding-right: 8px;
    float: right;
    color: white;
    font-size: 12px;
    &-btn {
      color: #ff663b;
      cursor: pointer;
      font-weight: bold;
    }
  }
}
</style>
